import {Fragment} from "react";

function InfoItem({label, value, className = "", labelClassName = "", valueClassName = "", span = 1, dots = true, children}) {
    const isEmpty = value === null || value === undefined || value === "";

    return (
        <p className={`${spanClass[span] ?? ""} text-[13px]! text-[#4f4f4f] break-words! ${className}`}>
            {label && <span className={`${labelClassName}`}>{label}{dots === true ? ':' : ''} </span>}

            { children ? (
                children
            ) : isEmpty ? (
                <span className={`ml-1 text-[14px]! font-normal italic text-[rgb(137,137,137)] ${valueClassName}`}>
                    Não informado
                </span>
            ) : (
                <span className={`text-[14px] font-normal text-[#161616] ${valueClassName}`}>
                    {value}
                </span>
            )}
        </p>
    );
}

const columnsClass = {
    1: "grid-cols-1",
    2: "grid-cols-2",
    3: "grid-cols-3",
    4: "grid-cols-4",
    5: "grid-cols-5",
};

const spanClass = {
    1: "col-span-1",
    2: "col-span-2",
    3: "col-span-3",
    4: "col-span-4",
    5: "col-span-5",
};

export default function InfoGrid({ title, items = [], columns = 2, className = "", contentClassName = "", titleClassName = "", subTitleClassName = "", labelClassName = "", valueClassName = "", divisorClassName  = "", divisor = false }) {
    return (
        <article className={`space-y-4 px-5 ${className}`}>
            { title && (
                <h2 className={`w-full rounded-[5px] border border-[#e0e0e0] bg-[#efefef] py-0! text-center text-lg! text-[#4f4f4f] print:break-after-avoid! ${titleClassName}`}>
                    {title}
                </h2>
            )}

            <section className={`grid gap-2 ${columnsClass[columns] ?? columnsClass[1]} ${contentClassName}`}>
                { items.map((item, index) => {

                    if (item.subTitle) {

                        if (item.groupedSections) {
                            return (
                                <Fragment key={index}>
                                    <div className={`space-y-1 print:break-inside-avoid! ${item.className}`}>
                                        <div className={`text-[16px] font-semibold text-[#4F4F4F] print:break-after-avoid! ${subTitleClassName} ${item?.subTitleClassName ?? ""}`}>
                                            {item.subTitle}
                                        </div>

                                        <div className="grid gap-2">
                                            { item.items.map((subItem, subIndex) => (
                                                <InfoItem key={`${index}-${subIndex}`} label={subItem.label} value={subItem.value} className={subItem.className} span={subItem.span} labelClassName={`${labelClassName} ${subItem.labelClassName}`} valueClassName={`${valueClassName} ${subItem.valueClassName}`} dots={subItem.dots}>
                                                    {subItem.children}
                                                </InfoItem>
                                            ))}
                                        </div>
                                    </div>

                                    { divisor && index < items.length - 1 && (
                                        <div className={`col-span-full w-full rounded-[5px] border border-[#e0e0e0] bg-[#efefef] py-0! ${divisorClassName}`}/>
                                    )}
                                </Fragment>
                            );
                        }

                        return (
                            <Fragment key={index}>
                                <div className={`col-span-full grid gap-2 ${columnsClass[columns] ?? columnsClass[1]} ${contentClassName} ${item.contentClassName ?? ""} ${item.className} print:break-inside-avoid!`}>
                                    <div className={`${spanClass[item.subTitleSpan] ?? ""} ${!item?.inlineContent ? "col-span-full pt-2" : ""} text-[16px] font-semibold text-[#4F4F4F] print:break-after-avoid! ${subTitleClassName} ${item?.subTitleClassName ?? ""}`}>
                                        {item.subTitle}
                                    </div>

                                    { item.items.map((subItem, subIndex) => (
                                        <InfoItem key={`${index}-${subIndex}`} label={subItem.label} value={subItem.value} className={subItem.className} span={subItem.span} labelClassName={`${labelClassName} ${subItem.labelClassName ?? ""}`} valueClassName={`${valueClassName} ${subItem.valueClassName}`} dots={subItem.dots}>
                                            {subItem.children}
                                        </InfoItem>
                                    ))}
                                </div>

                                { divisor && index < items.length - 1 && (
                                    <div className={`col-span-full w-full rounded-[5px] border border-[#e0e0e0] bg-[#efefef] py-0! ${divisorClassName}`}/>
                                )}
                            </Fragment>
                        );
                    }

                    return (
                        <>
                            <InfoItem key={index} label={item.label} value={item.value} className={item.className} span={item.span} labelClassName={`${labelClassName} ${item.labelClassName ?? ""}`} valueClassName={`${valueClassName} ${item.valueClassName ?? ""}`} dots={item.dots}>
                                {item.children}
                            </InfoItem>

                            { divisor && index < items.length - 1 && (
                                <div className={`col-span-full w-full rounded-[5px] border border-[#e0e0e0] bg-[#efefef] py-0! ${divisorClassName}`}/>
                            )}
                        </>
                    );
                })}
            </section>
        </article>
    );
}